import { AccordionLabel, AccordionPanel } from '@care/react-component-lib';
import { Accordion, makeStyles } from '@material-ui/core';
import React, { FC } from 'react';
import { AmplitudeLogger } from '@/utilities/analyticsHelper';
import { EventNames } from '@/constants';
import BenefitDetails from '../BenefitDetails/BenefitDetails';
import { Benefit } from '../../../types/types';

export const useStyles = makeStyles((theme) => ({
  // todo: reach out to web platform about overriding these accordion styles
  accordionContainer: {
    '& .MuiAccordionSummary-root': {
      borderBottom: `1px solid ${theme.palette.grey[300]}`,
      height: 'auto',
      alignItems: 'flex-start',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
    },

    '& .MuiAccordion-root:last-of-type .MuiAccordionSummary-root': {
      borderBottom: 'none',
    },

    '& .MuiAccordionSummary-content': {
      margin: 0,
      flexDirection: 'column',
    },

    '& .accordion-label-primary p': {
      fontWeight: 'bold',
      fontSize: '1.25rem',
      lineHeight: '21px',
    },
  },
}));

interface BenefitsAccordionsProps {
  benefits: Benefit[];
  logger: AmplitudeLogger;
}

const BenefitsAccordions: FC<BenefitsAccordionsProps> = ({ benefits, logger }) => {
  const classes = useStyles();

  const accordionClick = (linkText: string) => {
    logger({
      name: EventNames.LINK_INTERACTED,
      data: {
        link_text: `${linkText} clicked`,
      },
    });
  };

  return (
    <div data-testid="BenefitsAccordions" className={classes.accordionContainer}>
      {benefits.map((benefit) => (
        <Accordion key={benefit.title} elevation={0} onChange={() => accordionClick(benefit.title)}>
          <AccordionLabel primaryLabel={benefit.title} secondaryLabel={benefit.headline} />
          <AccordionPanel noPadding>
            <BenefitDetails benefit={benefit} />
          </AccordionPanel>
        </Accordion>
      ))}
    </div>
  );
};

export default BenefitsAccordions;
